import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { createSelector, ParametricSelector } from 'reselect';

import { routeToTableSpecificScope } from '../../helpers';
import { RootState } from '../reducers';
import {
  changeTablePropertiesOrderColumn,
  changeTablePropertiesPinnedRows,
  changeTablePropertiesScroll,
  changeTablePropertiesSelectedRows,
  replaceTableProperties
} from '../actions';
import { TableProperties, TablePropertiesScroll, TablePropertiesState } from '../types';
import { useCallback } from 'react';

// TODO: Learning createSelector, REVIEW TYPE
const selectTablePropertiesState: ParametricSelector<RootState, string | undefined, { tableProperties: TableProperties, orderColumn: number, pinnedRows: string[], selectedRows: string[] }> =
  createSelector(
    (state:any, forceScope: any) => forceScope || routeToTableSpecificScope(state.router.location.pathname),
    (state:any) => state.tableProperties,
    (scope, tableProperties) => {
      const { orderColumn = 0, pinnedRows = [], selectedRows = [] } = tableProperties[scope] || {};
      return { tableProperties: tableProperties[scope] || {}, orderColumn, pinnedRows, selectedRows };
    }
  );

export const useTablePropertiesState = (forceScope?: string) => {
  return useSelector((state: RootState) => selectTablePropertiesState(state, forceScope), shallowEqual);
};

export const useTablePropertiesDispatch = () => {
  const dispatch = useDispatch();
  return {
    changeOrderColumn: useCallback((order: number, isPersistent?: boolean, forceScope?: string) => () => dispatch(changeTablePropertiesOrderColumn(order, isPersistent, forceScope)), [dispatch]),
    changePinnedRows: useCallback((pinnedRows: string[], isPersistent?: boolean, forceScope?: string, linkPinnedRows?: string[]) => () => {
      dispatch(changeTablePropertiesPinnedRows(pinnedRows, isPersistent, forceScope));
      if (linkPinnedRows) {
        for (const scope of linkPinnedRows) {
          dispatch(changeTablePropertiesPinnedRows(pinnedRows, isPersistent, scope));
        }
      }
    }, [dispatch]),
    changeSelectedRows: useCallback((selectedRows: string[], isPersistent: boolean, forceScope?: string, linkSelectedRows?: string[], onChangeSelectedRows?:
      (selectedRows: string []) => void) => () => {
      if (onChangeSelectedRows) {
        onChangeSelectedRows(selectedRows);
      }
      dispatch(changeTablePropertiesSelectedRows(selectedRows, isPersistent, forceScope));
    }, [dispatch]),
    changeScroll: useCallback((scroll: TablePropertiesScroll, isPersistent: boolean, forceScope?: string) => () => dispatch(changeTablePropertiesScroll(scroll, isPersistent, forceScope)), [dispatch]),
    replaceTableProperties: useCallback((
      orderColumn: number, pinnedRows: string[], selectedRows: string[], scroll: TablePropertiesScroll,
      defaultProperties?: TableProperties, isPersistent?: boolean, forceScope?: string,
      linkPinnedRows?: string[]
    ) => () => {
      if (linkPinnedRows) {
        for (const scope of linkPinnedRows) {
          dispatch(changeTablePropertiesPinnedRows(
            pinnedRows || (defaultProperties && defaultProperties.pinnedRows ? defaultProperties.pinnedRows : undefined),
            isPersistent, scope)
          );
        }
      }
      dispatch(replaceTableProperties(
        orderColumn || (defaultProperties && defaultProperties.orderColumn ? defaultProperties.orderColumn : undefined),
        pinnedRows || (defaultProperties && defaultProperties.pinnedRows ? defaultProperties.pinnedRows : undefined),
        selectedRows || (defaultProperties && defaultProperties.selectedRows ? defaultProperties.selectedRows : undefined),
        isPersistent,
        forceScope
      ));
    }, [dispatch])
  };
};
